import { login } from '../Api/api';
import React from 'react';
import { Form, Input, Button, Message } from '@arco-design/web-react';
import { IconUser, IconLock } from '@arco-design/web-react/icon';
import { useNavigate } from 'react-router-dom';

// LoginLogo 组件
function LoginLogo() {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 30 }}>
      <img src="/favicon.svg" alt="favicon" style={{ width: 30, marginRight: 10 }} />
      <h5 style={{ color: '#3491FA', fontWeight: 700, fontSize: 22, margin: 0 }}>智网识客</h5>
    </div>
  );
}

// LoginCard 组件
function LoginCard({ children }) {
  return (
    <div style={{
      width: 300,
      background: 'rgba(255,255,255,0.9)',
      borderRadius: 8,
      boxShadow: '0 2px 16px 0 rgba(0,0,0,0.08)',
      padding: 20,
      marginLeft: '50vw',
      marginTop: '-68px',
      marginRight: 500
    }}>
      {children}
    </div>
  );
}

// LoginBg 组件
function LoginBg({ children }) {
  return (
    <div style={{
      minHeight: '100vh',
      width: '100vw',
      background: "url('https://picx.zhimg.com/70/v2-52dbe8bdb0e4854c1e5bd39ff75a68d6_1440w.avis?source=172ae18b&biz_tag=Post') no-repeat center center",
      backgroundSize: 'cover',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
    }}>
      {children}
    </div>
  );
}

export default function Login() {
  const navigate = useNavigate();

  // 表单提交
  const handleSubmit = async (values) => {
    try {
      // 1. 调用接口
      const res = await login(values.username, values.password);
      console.log('登录响应:', res);
      
      // 2. 根据接口返回结果判断是否登录成功
      if (res && (res.status === 200 || res.msg === 'success' || res.success)) {
        console.log('登录成功，token:', res.token);
        
        // 检查token是否存在
         if (res.token) {
           const pureToken = res.token.replace(/^Bearer\s+/i, '');
           localStorage.setItem('token', pureToken);
           console.log('Token已保存到localStorage:', pureToken);
           Message.success('登录成功');
           
           // 使用setTimeout确保localStorage更新完成后再导航
           setTimeout(() => {
             console.log('准备跳转到/home');
             navigate('/home', { replace: true });
             // 如果导航失败，强制刷新页面
             setTimeout(() => {
               if (window.location.pathname === '/login') {
                 console.log('导航可能失败，强制刷新页面');
                 window.location.href = '/home';
               }
             }, 100);
           }, 50);
         } else {
          console.error('登录成功但未返回token');
          Message.error('登录成功但未获取到认证信息，请重试');
        }
      } else {
        console.log('登录失败，响应:', res);
        const errorMsg = res && res.msg ? res.msg : (res && res.error ? res.error : '登录失败');
        Message.error(errorMsg);
      }
    } catch (err) {
      console.error('登录异常:', err);
      const errorMsg = err.message || '网络错误或用户名密码错误';
      Message.error(errorMsg);
    }
  };

  return (
    <LoginBg>
      <LoginCard>
        <LoginLogo />
        <Form layout="vertical" onSubmit={handleSubmit}>
          <Form.Item field="username" rules={[{ required: true, message: '请输入账户名' }]}>
            <Input prefix={<IconUser />} placeholder="请输入账户名" />
          </Form.Item>
          <Form.Item field="password" rules={[{ required: true, message: '请输入密码' }]}>
            <Input.Password prefix={<IconLock />} placeholder="请输入密码" />
          </Form.Item>
          <Button shape='round' type="primary" long style={{ marginTop: 8 }} htmlType="submit">
            登录
          </Button>
        </Form>
      </LoginCard>
    </LoginBg>
  );
}
